const path = require("path");

/** @type {import('next-i18next').UserConfig} */
module.exports = {
    i18n: {
        defaultLocale: "en",
        locales: ["en", "de"],
        localeDetection: false,
    },
    localePath: path.resolve("./public/locales"),
    reloadOnPrerender: process.env.NODE_ENV === "development",
    serializeConfig: false,
    fallbackLng: false,
    load: "currentOnly",
    showSupportNotice: false,
    customLogger: {
        log: () => {},
        warn: console.warn.bind(console),
        error: console.error.bind(console),
    },
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
        console.warn(`[i18n] Missing key "${key}" in namespace "${ns}" for locale(s): ${lngs.join(", ")}`);
    },
};
